// New record IDs. The apps make them with Swift's UUID, whose text is upper case, and use it as the document's ID as
// well as its `id` field: a lower-case ID would name a second document for the same record (docs/47, rule 1).

const UUID_PATTERN = /^[0-9A-Fa-f]{8}-[0-9A-Fa-f]{4}-[0-9A-Fa-f]{4}-[0-9A-Fa-f]{4}-[0-9A-Fa-f]{12}$/;

/** A new ID: a random UUID in upper case, as Swift writes it. */
export function newID(): string {
  return crypto.randomUUID().toUpperCase();
}

/** Whether the text is a UUID in any case, as Swift's `UUID(uuidString:)` accepts it. */
export function isUUID(text: unknown): text is string {
  return typeof text === "string" && UUID_PATTERN.test(text);
}

/** The UUID as Swift writes it back (upper case), or null when the text isn't one. */
export function normalizedUUID(text: unknown): string | null {
  return isUUID(text) ? text.toUpperCase() : null;
}
